// Email popup: waits for a delay or real scroll depth (whichever first), then snoozes
// after any close or any signup. Snooze lives in localStorage; if storage is blocked it
// just won't show. Horizon scrolls .page-wrapper on desktop, so scroll comes from there.
import { getScrollContainer, getScrollEventTarget } from '@theme/scroll-container';

const KEY = 'nr-popup-snooze-until';

function snoozed() {
  try {
    return Number(localStorage.getItem(KEY) || 0) > Date.now();
  } catch {
    return true;
  }
}

function snooze(days) {
  try {
    localStorage.setItem(KEY, String(Date.now() + days * 86400000));
  } catch {
    /* storage blocked: nothing to remember */
  }
}

let teardown = () => {};

function init(dialog) {
  teardown();
  const days = Number(dialog.dataset.days) || 30;
  const posted = new URLSearchParams(location.search).has('customer_posted');
  const controller = new AbortController();
  const { signal } = controller;

  dialog.querySelectorAll('[data-nr-popup-close]').forEach((btn) => btn.addEventListener('click', () => dialog.close(), { signal }));
  dialog.addEventListener('close', () => snooze(days), { signal });
  // Click on the backdrop closes it
  dialog.addEventListener('click', (event) => event.target === dialog && dialog.close(), { signal });

  let timer = 0;
  const scrollTarget = getScrollEventTarget();
  const cleanup = () => {
    clearTimeout(timer);
    scrollTarget.removeEventListener('scroll', onScroll);
  };

  function open() {
    if (!dialog.isConnected) return cleanup();
    // Never stack on the cart drawer, another open dialog or a running decal garage; scroll can still trigger it later
    if (dialog.open || snoozed() || document.querySelector('dialog[open], [data-nr-garage][data-state="live"], [data-nr-garage][data-state="loading"]')) return;
    cleanup();
    dialog.showModal();
  }

  function onScroll() {
    const sc = getScrollContainer();
    const max = sc.scrollHeight - sc.clientHeight;
    const depth = (Number(dialog.dataset.scroll) || 60) / 100;
    if (max > 0 && sc.scrollTop / max >= depth) open();
  }

  teardown = () => {
    cleanup();
    controller.abort();
  };

  if (dialog.dataset.preview === 'true') {
    dialog.showModal();
  } else if (posted && location.hash === '#nr-popup-signup') {
    // Came back from submitting the popup form: show the success state once.
    snooze(days);
    dialog.showModal();
  } else if (posted || snoozed()) {
    // Signed up through any form: don't ask again.
    if (posted) snooze(days);
  } else {
    timer = setTimeout(open, (Number(dialog.dataset.delay) || 30) * 1000);
    scrollTarget.addEventListener('scroll', onScroll, { passive: true });
  }
}

const first = document.querySelector('[data-nr-popup]');
if (first) init(first);

document.addEventListener('shopify:section:load', (event) => {
  const dialog = event.target.querySelector('[data-nr-popup]');
  if (dialog) init(dialog);
});
